import AccordionContainer from '../../components/ui/AccordionContainer'
import { ChartItem } from '../../components/features/Chart/ChartItem'
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@chakra-ui/react'
import { observer } from 'mobx-react'
import rootStore from '../../store/RootStore'
import { matchesFilters } from '@utils/ReportHelper'

export const SectionListItem = ({ data, isChild, onChange, ...rest }) => {
  const hasChartChildren = useMemo(
    () =>
      data.children.filter(
        content => content.componentType === 3 || content.componentType === 2
      ).length > 0,
    [data.children]
  )

  return (
    <AccordionContainer
      id={data.id}
      key={data.id}
      title={data.name}
      isChild={isChild}
      data-report-section-id={data.id}
      isDisabled="true"
      onChange={onChange}
      {...rest}>
      {hasChartChildren ? (
        <Flex wrap="wrap">
          <SectionItems
            data={data}
            onChange={onChange}
          />
        </Flex>
      ) : (
        <>
          <SectionItems
            data={data}
            onChange={onChange}
          />
        </>
      )}
    </AccordionContainer>
  )
}

const SectionItems = observer(({ data, onChange }) => {
  const {
    reportStore: { filterOptionsSelected },
  } = rootStore

  const sortedChildren = [...data.children].sort((a, b) => a.order - b.order)

  return sortedChildren.map(child => {
    let chartsFiltered = {}

    if (child.componentType === 3) {
      chartsFiltered =
        child.children.find(
          chart =>
            chart.filters.filter(
              f => filterOptionsSelected.get(f.name)?.value === f.value
            ).length === filterOptionsSelected.size
        ) || {}
    }

    switch (child.componentType) {
      case 1:
        return (
          <SectionListItem
            id={child.id}
            onChange={onChange}
            key={child.id}
            data={child}
            isChild={true}
          /*data-chart-id={child.id}*/
          />
        )
      case 2: {
        if(matchesFilters(child.filters, filterOptionsSelected)) {
          return <ChartItem
              key={child.id}
              index={child.id}
              chartId={child.id}
              data-chart-id={child.id}
          />
        }
        return null
      }

      case 3:
        return chartsFiltered.id ? (
          <ChartItem
            key={chartsFiltered.id}
            index={chartsFiltered.id}
            chartId={chartsFiltered.id}
            data-chart-id={chartsFiltered.id}
          />
        ) : null
      default:
        return null
    }
  })
})

SectionListItem.propTypes = {
  data: PropTypes.any,
  isChild: PropTypes.bool,
}
